import { FC, useEffect, useState } from 'react';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';
import SelectSemesterCourseSubject from '../../SelectSemesterCourseSubject';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSemesterLessonPlans,
  ISemesterLessonPlan,
} from '../../../models/semesterLessonPlan2.model';
import useLoader from '../../../hooks/useLoader';
import { getSemesterLessonPlans } from '../../../api/semesterLessonPlan2.api';
import {
  IGetSemesterEvaluationPbtItems,
  IPostSemesterEvaluationPbtItem,
  ISemesterEvaluationPbtItem,
} from '../../../models/semesterEvaluation.model';
import { getEvaluationItemTree } from '../../../api/evaluationItem.api';
import { IGetEvaluationItemTree } from '../../../models/evaluationItem.model';
import { Select, Table, TableColumnsType } from 'antd';
import {
  deleteSemesterEvaluation,
  getSemesterEvaluationPbtItems,
  postSemesterEvaluationPbtItem,
  putSemesterEvaluationPbtItem,
} from '../../../api/semesterEvaluation.api';
import _ from 'lodash';
import useNotification from '../../../hooks/useNotification';

interface IProps {
  semesterCourseCode?: number;
}

const EvaluationPbt: FC<IProps> = ({ semesterCourseCode }) => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetEvaluationItemTree>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSemesterLessonPlans>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetSemesterEvaluationPbtItems>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios<IPostSemesterEvaluationPbtItem>();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();
  useLoader(
    isLoading || isLoading2 || isLoading3 || submitIsLoading || deleteIsLoading,
    [error, error2, error3, submitError, deleteError],
  );

  const [subjectCode, setSubjectCode] = useState<number>();
  const [lessonPlanCode, setLessonPlanCode] = useState<number>();
  const [formData, setFormData] = useState<ISemesterEvaluationPbtItem[]>([]);
  const [rowIndex, setRowIndex] = useState<number>();
  console.log('subjectCode', subjectCode);
  const newRow = {
    evaluationCode: 0,
    evaluationItemCode: 0,
    questionCount: '',
  };

  useEffect(() => {
    execute(getEvaluationItemTree('PB'));
  }, []);

  useEffect(() => {
    if (semesterCourseCode && subjectCode) {
      execute2(
        getSemesterLessonPlans({
          semesterCourseCode,
          subjectCode,
        }),
      );
    }
  }, [semesterCourseCode, subjectCode]);

  useEffect(() => {
    if (lessonPlanCode) {
      execute3(
        getSemesterEvaluationPbtItems({
          lessonPlanCode,
        }),
      );
    }
  }, [lessonPlanCode]);

  useEffect(() => {
    if (res3) {
      if (res3.data?.length) {
        setFormData(_.cloneDeep(res3.data));
      } else {
        setFormData([newRow]);
      }
    }
  }, [res3]);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
      const newFormData: any = [...formData];
      newFormData[rowIndex!] = { ...submitRes.data };
      setFormData(newFormData);
    }
  }, [submitRes]);

  useEffect(() => {
    if (deleteRes) {
      setFormData(formData.filter((_, index) => index !== rowIndex));
    }
  }, [deleteRes]);

  const onSetFormData = (
    index: number,
    key: keyof ISemesterEvaluationPbtItem,
    value: number | string,
  ) => {
    if (key === 'evaluationItemCode') {
      const isExist = formData.find(
        (item, index2) => index !== index2 && item.evaluationItemCode === value,
      );
      if (isExist) {
        return infoNotification(t('program.semester.6'));
      }
    }
    if (key === 'questionCount' && isNaN(Number(value))) {
      return;
    }
    const newFormData: any = [...formData];
    newFormData[index][key] = value;
    setFormData(newFormData);
  };

  const onAdd = () => {
    setFormData([...formData, newRow]);
  };

  const isDisabled = (evaluationItemCode: number) => {
    const evaluationItem = res?.data?.find(
      (item) => item.evaluationItemCode === evaluationItemCode,
    );
    if (evaluationItem?.inputTypeCode === 'PC') {
      return false;
    }
    return true;
  };

  const onSubmit = (index: number, row: ISemesterEvaluationPbtItem) => {
    if (!row.evaluationItemCode) {
      return infoNotification(t('program.semester.7'));
    }
    if (!isDisabled(row.evaluationItemCode) && !row.questionCount) {
      return infoNotification(t('program.semester.8'));
    }

    setRowIndex(index);

    const req: any = {
      lessonPlanCode: lessonPlanCode!,
      evaluationType: 'PB',
      evaluationItemCode: row.evaluationItemCode,
    };
    if (!isDisabled(row.evaluationItemCode)) {
      req.questionCount = Number(row.questionCount);
    }

    if (row.evaluationCode) {
      submitExecute(putSemesterEvaluationPbtItem(row.evaluationCode, req));
    } else {
      submitExecute(postSemesterEvaluationPbtItem(req));
    }
  };

  const onDelete = (index: number, evaluationCode: number) => {
    if (evaluationCode) {
      setRowIndex(index);
      deleteExecute(deleteSemesterEvaluation(evaluationCode));
    } else {
      setFormData(formData.filter((_, index2) => index !== index2));
    }
  };
  console.log('res', res);
  const columns: TableColumnsType<ISemesterEvaluationPbtItem> = [
    {
      title: t('program.semester.9'),
      dataIndex: 'evaluationItemCode',
      width: '40%',
      render: (_, __, index) => (
        <Select
          placeholder={t('student.student.placeholder6')}
          value={formData[index].evaluationItemCode || null}
          onChange={(value) =>
            onSetFormData(index, 'evaluationItemCode', value)
          }
          style={{ width: '100%' }}
        >
          {/* {res?.data?.map(({ evaluationItemCode, evaluationItemName }) => ( */}
          {res?.data
            ?.filter((item: any) => item.subjectCode === subjectCode)
            .map(
              (
                { evaluationItemCode, evaluationItemName }, //20240820 pbt과목별 activity표출되도록 수정
              ) => (
                <Select.Option
                  key={evaluationItemCode}
                  value={evaluationItemCode}
                >
                  {evaluationItemName}
                </Select.Option>
              ),
            )}
        </Select>
      ),
    },
    {
      title: t('program.semester.10'),
      dataIndex: 'evaluationItemCode',
      render: (_, __, index) => (
        <input
          type="text"
          className="form-control w-100p"
          value={formData[index].questionCount}
          onChange={(e) =>
            onSetFormData(index, 'questionCount', e.target.value)
          }
          maxLength={3}
          disabled={isDisabled(formData[index].evaluationItemCode)}
        />
      ),
    },
    {
      title: t('common.button.save'),
      dataIndex: 'semesterSeqEvaluationCode',
      render: (_, record, index) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small pink"
            onClick={() => onSubmit(index, record)}
            text={t('common.button.save')}
          />
        </div>
      ),
    },
    {
      title: t('common.button.delete'),
      dataIndex: 'evaluationCode',
      render: (value, _, index) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small gray"
            onClick={() => onDelete(index, value)}
            text={t('common.button.delete')}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <div className="w-150p">
            <SelectSemesterCourseSubject
              semesterCourseCode={semesterCourseCode}
              subjectCode={subjectCode}
              setSubjectCode={setSubjectCode}
            />
          </div>
        </div>
      </div>
      {res2?.data && (
        <div className="flex flex-column">
          <div className="comm-bx__space">
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                text={t('program.semester.button6')}
                onClick={onAdd}
              />
            </div>
          </div>
          <div className="flex">
            <div className="col-4 comm-table__area mt-0 pl-0 pr-0">
              <table>
                <colgroup>
                  <col width="50%" />
                  <col width="50%" />
                </colgroup>
                <thead>
                  <tr>
                    <th className="text-center">{t('program.semester.4')}</th>
                    <th className="text-center">Lesson</th>
                  </tr>
                </thead>
                <tbody>
                  {res2.data.map((item: ISemesterLessonPlan, index: number) => (
                    <tr
                      key={index}
                      className={
                        lessonPlanCode === item.lessonPlanCode
                          ? 'chosen'
                          : 'pointer'
                      }
                      onClick={() => {
                        setLessonPlanCode(item.lessonPlanCode);
                      }}
                    >
                      <td className="text-center">{item.subjectSeq}</td>
                      <td className="text-center">{item.lessonName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-8 pr-0">
              {formData.length ? (
                <Table
                  className='comm-table__area mt-0'
                  columns={columns}
                  dataSource={formData}
                  pagination={false}
                />
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EvaluationPbt;
